<template>
    <va-edit-layout>
        <RefundEvent-form
            :id="id"
            :title="title"
            :item="item"
        ></RefundEvent-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
